import React, { Component } from 'react'
import './SoldOutProduct.css'
import { createOrderIntention, updateOrderIntention } from './scripts/createOrderIntention'
import Product_thumbnails from '../../Layouts/Layouts_product/Product_thumbnails/Product_thumbnails'
import numeral from 'numeral'
import { onlyOnePurchaseButtonVisible } from '../Product/Scripts/onlyOnePurchaseButtonVisible'
import PureModal from 'react-pure-modal';
import 'react-pure-modal/dist/react-pure-modal.min.css';
import ButtonForm from '../../Layouts/Layouts_PurchaseForm/ButtonForm/ButtonForm'
import InputForm from '../../Layouts/Layouts_PurchaseForm/InputForm/InputForm'
import bestSeller from '../../Assets/16902725561bbf1a4128275fa9bda56d25e07f08b6.png'
import SellsAlerts from './SellsAlerts'
import LoaderPage from '../../Global_Layouts/LoaderPage/LoaderPage'
import Loader from '../../Global_Layouts/Loader/Loader'
import { manageLocalStorage } from '../../Helpers/manageLocalStorage'
import TiktokPixel from 'tiktok-pixel';
import {generateFirebaseId} from '../../Helpers/generateAFirebaseId'

export default class SoldOutProduct extends Component {

  state = {
    intentionId: null,
    ciclo: null,
    product_ciclo_id: null,
    soldout_product_data: null,

    first_name: "",
    last_name: "",
    phone_number: null,
    address1: "",
    address2: "",
    province: "",
    city: "",
    contact_email: "",
    note: "",
    customer_selected_size: "",
    customer_selected_color: "",
    customer_open_question_answer: "",

    showFormModal: false,
    showLoader: false,
    showSoldOutMessage: false,
    customer_want_to_reserve_the_product: false,
    product_reserved: false,

    AddToCart: false,
    comodinIdStore: this.props.storeData.comodinIdStore
  }

  componentDidMount = async () => {
    this.getCID()
    onlyOnePurchaseButtonVisible()
  }

  componentDidUpdate(prevProps) {
    if (this.props.UTM_params !== prevProps.UTM_params || this.props.storeData !== prevProps.storeData) {
      this.getCID();
    }
  }



  getCID = () => {
    const {UTM_params, storeData} = this.props
    const c = UTM_params?.filter((utm) => utm.name === "c")[0].value
    const id = UTM_params?.filter((utm) => utm.name === "id")[0].value
    // const ciclo = isNaN(parseInt(c))? c : parseInt(c)
    // const product_ciclo_id = isNaN(parseInt(id))? id : parseInt(id)
    const ciclo = /^\d+$/.test(c) ? parseInt(c) : c;
    const product_ciclo_id = /^\d+$/.test(id) ? parseInt(id) : id;
    // console.log("ciclo", ciclo)
    // console.log("product_ciclo_id", product_ciclo_id)
    // console.log("storeData?.products", storeData?.products)
    const soldout_product_data = storeData?.products?.filter((product) => product.ciclo === ciclo && product.product_ciclo_id === product_ciclo_id)[0] ?? null
    console.log("soldout_product_data", soldout_product_data)
    const aux_cid = ciclo.toString() + product_ciclo_id.toString();
    const soldOutCids = manageLocalStorage("sold_out_cid", undefined, "array");
    const reservedCids = manageLocalStorage("product_reserved_cid", undefined, "array");
    const aux_showSoldOutMessage = soldOutCids.includes(aux_cid);
    const aux_product_reserved = reservedCids.includes(aux_cid);

    this.setState({
        soldout_product_data,
        ciclo,
        product_ciclo_id,
        aux_cid,
        showSoldOutMessage: aux_showSoldOutMessage,
        product_reserved: aux_product_reserved,
    })
  }

  readData = (e) => {
    this.setState({
        [e.target.id]: e.target.value
    })
  }

  select_sizes = (option) => {
    this.setState({
        customer_selected_size: option
    })
  }

  select_colors = (option) => {
    this.setState({
        customer_selected_color: option
    })
  }

  ToggleShowModal = () => {
    this.setState({ showFormModal: !this.state.showFormModal  })
  }

  onModalClose = (e) =>{
    this.setState({showFormModal: false, showLoader:false})
    return true;
  }

  createOrderIntentionHandle = async (e) => {
    e.preventDefault()

    window.fbq('track', 'Purchase', {currency: "COP", value: 129900});
    window.pintrk('track', 'Checkout', {currency: "COP", value: 129900});
    
    TiktokPixel.track('CompletePayment', {
        content_type: 'product',
        content_id: generateFirebaseId(),
        currency: 'COP',
        value: 129900,
    });

    manageLocalStorage("sold_out_cid", this.state.aux_cid, "array")
    this.setState({showLoader: true})
    let intentionId = await createOrderIntention({
        ...this.state,
        created_at: new Date(),
    })
    setTimeout(() => {
      this.setState({showLoader: false, showSoldOutMessage: true, intentionId})
    }, 4000);
  }

  customerWantTheProduct = async () => {
    this.setState({showLoader: true})
    manageLocalStorage("product_reserved_cid", this.state.aux_cid, "array")
    let data_to_update = {
      is_update: true,
      id: this.state.intentionId,
      data_to_update: {customer_want_to_reserve_the_product: true}
    }
    await updateOrderIntention(data_to_update)
    setTimeout(() => {
      this.setState({showLoader: false, customer_want_to_reserve_the_product: true, product_reserved: true})
    }, 4000);
  }

  createDraftIntention = () => {
    if (this.state.AddToCart === false && this.state.phone_number) {
      window.fbq('track', 'AddToCart');
      window.pintrk('track', 'AddToCart');
      
      TiktokPixel.track('AddToCart', {
        content_type: 'product',
        content_id: 'ID_del_producto',
        currency: 'COP',
        value: 0,
        content_name: 'Nombre_del_producto',
        quantity: 1,
      });
      this.setState({AddToCart:true})
    }

    // TODO:

  }

  render() {
    const {storeData} = this.props
    const {soldout_product_data} = this.state
    console.log(this.state)
    // const soldout_product_data = {
    //     product_img_src: [
    //         "https://cdn.shopify.com/s/files/1/0040/8997/0777/files/cute_rabbit_2_1024x1024.jpg?v=1696637386",
    //         "https://static.wixstatic.com/media/e8ae4b_904fc5c4a144413ea5dd4a2b69059620~mv2.png/v1/fill/w_282,h_170,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/R-1.png",
    //         "https://static.wixstatic.com/media/e8ae4b_904fc5c4a144413ea5dd4a2b69059620~mv2.png/v1/fill/w_282,h_170,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/R-1.png",
    //         "https://static.wixstatic.com/media/e8ae4b_904fc5c4a144413ea5dd4a2b69059620~mv2.png/v1/fill/w_282,h_170,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/R-1.png",
    //         "https://static.wixstatic.com/media/e8ae4b_904fc5c4a144413ea5dd4a2b69059620~mv2.png/v1/fill/w_282,h_170,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/R-1.png",
    //     ],
    //     product_name: "Producto de prueba",
    //     product_price: 129900,
    //     product_sizes: ["33", "34", "35", "36", "37", "38"],
    //     product_colors: ["Negro", "Blanco", "Rojo", "Azul", "Verde"],
    //     is_sold_out: true
    // }
    
    if (!soldout_product_data) {
        return (
          <div>
            <LoaderPage storeData={storeData}/>
          </div>
        )
    }

    const {product_img_src, product_name, product_price, product_sizes, product_colors, gender} = soldout_product_data
    const {product_ciclo_id, showFormModal} = this.state
    const {first_name, last_name, phone_number, address1, address2, province, city, contact_email, note, customer_selected_size, customer_selected_color, customer_open_question_answer} = this.state
    const comodin_comparative_price = product_price * 1.5
  
    return (
      <div className='SoldOutProduct'>
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-12 col-lg-6">
                    <Product_thumbnails mainImage={product_img_src[0]} images={product_img_src}/>
                </div>
                <div className="col-md-12 col-lg-6">
                    <div className='Product_data_title'>{product_name}</div>
                    <div className="Product_data_separator"></div>
                    <div className='Product_data_discount'>{ Math.round(((comodin_comparative_price - product_price) / comodin_comparative_price)*100 )}% DESCUENTO </div>
                    <div className='Product_data_prices'>
                        <div className='Product_data_price'>{numeral(product_price).format('$ 0,0[.]00')}</div>
                        <div className='Product_data_comparative_price'>{numeral(comodin_comparative_price).format('$ 0,0[.]00')}</div>
                    </div>
                    <div>
                        <div className='lastUnits'>
                            <img style={{width:"20px", height:"auto", marginRight:"6px", marginLeft:"6px"}} src={bestSeller} alt="" />
                            {/* #{product_ciclo_id?.toString()?.charAt(product_ciclo_id.toString().length - 1)} Best Sellers - Ultimas unidades disponibles */}
                            #1 Best Sellers - Ultimas unidades disponibles
                        </div>
                        <div className='moreComing'>
                            Vienen más en camino
                        </div>
                        {/* <div className='activeUsers'>
                            25 Visitantes activos
                        </div> */}
                    </div>
                    <div className="Product_data_separator"></div>
                    <Variations_selector_boxes label={"Talla"} selected_value={customer_selected_size} options_array={product_sizes} select_option={this.select_sizes} />
                    <Variations_selector_boxes label={"Color"} selected_value={customer_selected_color} options_array={product_colors} select_option={this.select_colors} />
                    <div id='Product_data_purchase_btn'>
                        <button className='PurchaseButton' onClick={this.ToggleShowModal}>COMPRAR AHORA - PAGA AL RECIBIR</button>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12 d-flex justify-content-center">
                    <div className='Product_content'>
                        {
                            product_img_src.map(img=>
                                <div className="row">
                                    <div className='Product_content_section'> 
                                        <img src={img} alt="" />
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
        <div id='sticky_purchase_btn' className='sticky-footer'>
            <button className='PurchaseButton' onClick={this.ToggleShowModal}>COMPRAR AHORA - PAGA AL RECIBIR</button>
        </div>

        <PureModal
          header="Checkout"
          width='94%'
          isOpen={showFormModal}
          closeButton="Cerrar"
          closeButtonPosition="header"
          onClose={this.onModalClose}
        >
          {
            this.state.showLoader===true?
              <Loader first_name={first_name} statusLabel={ this.state.showSoldOutMessage?"Reservando":"Creando" }/>
            :
            this.state.showSoldOutMessage===true?
              <div style={{wordBreak:"keep-all"}}>
                <h3 style={{lineHeight:"1", backgroundColor:"#dcffed", color:"#00a650", maxWidth:"max-content"}}>{this.state.product_reserved!==true? "Agotado por alta demanda. Pronto, más stock" : "Reserva confirmada"}</h3>
                {
                  this.state.product_reserved===true && (
                    <div style={{marginTop:"-5px", color:"grey"}}>{this.state.intentionId}</div>
                  )
                }
                {
                  this.state.product_reserved!==true && (
                    <p style={{marginTop:"25px"}}><strong>Reserva tu producto ahora.</strong> Te notificaremos tan pronto como hayamos reabastecido</p>
                  )
                }
                <div style={{marginTop:"25px"}}>
                  <strong>Reservaremos para ti:</strong>
                  <div>1 Par de {product_name}</div>
                  {
                    customer_selected_color && customer_selected_size && (
                      <div>Color {customer_selected_color} / Talla {customer_selected_size}</div>
                    )
                  }
                </div>
                <p style={{marginTop:"25px"}}><strong>Fecha estimada reabastecimiento: </strong> 15 - 30 dias</p>
                
                {
                  this.state.product_reserved!==true && (
                    <button style={{marginTop:"25px"}} className='PurchaseButton' onClick={this.customerWantTheProduct}>Quiero reservarlo</button>
                  )
                }
              </div>
            :
              <form onSubmit={this.createOrderIntentionHandle}>
              <InputForm onBlur={()=>this.setState({fillingForm: true})} input_required={true} input_value={first_name} input_type={"text"} with_label_text={true} label_text={"Nombres *"} label_htmlFor={"first_name"} with_small_text={false} small_text={null} input_id={"first_name"} input_placeholder={"Nombres"} onChange={this.readData}/>
              <InputForm input_required={true} input_value={last_name} input_type={"text"} with_label_text={true} label_text={"Apellidos *"} label_htmlFor={"last_name"} with_small_text={false} small_text={null} input_id={"last_name"} input_placeholder={"Apellidos"} onChange={this.readData}/>
              <InputForm onBlur={this.createDraftIntention} input_required={true} input_value={phone_number} input_type={"number"} with_label_text={true} label_text={"Celular *"} label_htmlFor={"phone_number"} with_small_text={false} small_text={null} input_id={"phone_number"} input_placeholder={"Celular (Preferiblemente con Whatsapp)"} onChange={this.readData}/>
              <InputForm input_required={true} input_value={address1} input_type={"text"} with_label_text={true} label_text={"Dirección de entrega *"} label_htmlFor={"address1"} with_small_text={false} small_text={null} input_id={"address1"} input_placeholder={"Dirección de entrega"} onChange={this.readData}/>
              <InputForm input_required={false} input_value={address2} input_type={"text"} with_label_text={true} label_text={"Indicaciones extra en la dirección (Opcional)"} label_htmlFor={"address2"} with_small_text={false} small_text={null} input_id={"address2"} input_placeholder={"Apto / Casa / Conjunto / Barrio (Opcional)"} onChange={this.readData}/>
              <InputForm input_required={true} input_value={province} input_type={"text"} with_label_text={true} label_text={"Departamento *"} label_htmlFor={"province"} with_small_text={false} small_text={null} input_id={"province"} input_placeholder={"Departamento"} onChange={this.readData}/>
              <InputForm onBlur={this.createDraftIntention} input_required={true} input_value={city} input_type={"text"} with_label_text={true} label_text={"Ciudad *"} label_htmlFor={"city"} with_small_text={false} small_text={null} input_id={"city"} input_placeholder={"Ciudad"} onChange={this.readData}/>
              <InputForm input_required={false} input_value={contact_email} input_type={"email"} with_label_text={true} label_text={"Email"} label_htmlFor={"contact_email"} with_small_text={false} small_text={null} input_id={"contact_email"} input_placeholder={"Email"} onChange={this.readData}/>
              {/* <div style={{backgroundColor:"#dcffed", color:"#00a650"}}>
                <strong>Recibe 5% descuento</strong>
              </div>
              <div style={{lineHeight:"1", wordBreak:"keep-all"}}>
                <strong>Cuentanos que es lo que más te gusta de este diseño </strong>
                <span>(El descuento se aplica al confirmar el pedido x Whatsapp)</span>
              </div> */}
              <InputForm input_required={false} input_value={note} input_type={"text"} with_label_text={true} label_text={"Nota adicional"} label_htmlFor={"note"} with_small_text={false} small_text={null} input_id={"note"} input_placeholder={"Confirmar detalles talla, color, etc"} onChange={this.readData}/>
              
              <div style={{marginBottom:"20px"}}>
                <div>
                  <span>- PARES:</span>
                  <strong> 1</strong>
                </div>
                <div>
                  <span>- COSTO ENVIO:</span>
                  <strong> GRATIS</strong>
                </div>
                <div>
                  <span>- TOTAL A PAGAR: </span>
                  <strong className='Product_data_price'>{numeral(product_price).format('$ 0,0[.]00')}</strong>
                </div>
              </div>

              <div className='lastUnits' style={{wordBreak:"keep-all"}}>
                  <img style={{width:"20px", height:"auto", marginRight:"6px", marginLeft:"6px"}} src={bestSeller} alt="" />
                  Producto con alta demanda. Se esta agotando muy rapido
              </div>
              <div className='moreComing'>
                  Vienen más en camino
              </div>

              <div style={{marginTop:"20px"}}>
                <ButtonForm type={"submit"} button_text={"COMPRAR AHORA - PAGAR AL RECIBIR"} />
              </div>

              <div style={{marginTop:"20px",width:"100%", minHeight:"130px"}}>
                <SellsAlerts gender={gender} product_imgs={product_img_src} fillSpace={true}/>
              </div>
              </form>
          }
        </PureModal>

        <SellsAlerts gender={gender} product_imgs={product_img_src} disabled={this.state.showSoldOutMessage}/>
      </div>
    )
  }
}
  
class Variations_selector_boxes extends Component {
    render() {
      const {label, selected_value, options_array, select_option} = this.props
      return (
        <div className='VariationsSelector_variations_boxes'>
          <div className='VariationsSelector_variations_boxes_option_box'>
              <div className='VariationsSelector_variations_box_label'>{label}: <span style={{color:"grey", fontWeight:"lighter", fontSize:"17px"}}>{selected_value}</span></div>
              <div className='VariationsSelector_variations_boxes_container'>
                {options_array.length > 0 ?
                    options_array.map((option) => 
                        <div className={`VariationsSelector_variations_box${selected_value === option?"_selected":""}`}
                            onClick={() => select_option(option)}
                            value={option}
                        >
                            {option}
                        </div>
                    )
                : null}
              </div>
          </div>
        </div>
      )
    }
  }

  